export enum PaymentTypes {
  Stripe,
  PayPal,
  Wallet,
  JazzCash,
  EasyPaisa,
}
export enum PaymentCodes {
  Stripe = 'MG-PM-001',
  PayPal = 'MG-PM-852',
  Wallet = 'MG-PM-003',
  JazzCash = 'MG-PM-005',
  EasyPaisa = 'MG-PM-006',
}

export enum BookingStatus {
  Paid,
  Pending,
  Expired,
}

export enum gtagEventTypes {
  purchase,
  booking,
}

export enum AccountType {
  Mentor,
  Mentee,
}

export enum AccountType_v2 {
  Creator = 1,
  Fan = 2,
  Both = 3,
}
export enum MentogaProducts {
  Text = 1,
  Audio,
  Video,
  Emeet,
}
export enum Currencies {
  dollar = 1,
}
export enum ChatProducts {
  Text = 1,
  Audio,
  Video,
}

export enum Products {
  Text = 1,
  Audio = 2,
  Video = 3,
  eMeet = 4,
  MegaSession = 5,
}
export enum ProductNames {
  Text = 'Text',
  Audio = 'Audio',
  Video = 'Video',
  eMeet = 'eMeet',
  MegaSession = 'MegaSession',
  MegaSessionRecording = 'MegaSessionRecording',
  Coffee = 'coffee',
}

export enum TransactionType {
  Credit = 1,
  Debit = 2,
}
export enum TransactionDescription {
  Stripe = 'Stripe Top-up',
  Paypal = 'Paypal Top-up',
}
